import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { createLayerContainer } from '@antv/l7-core';
import { EventEmitter } from 'eventemitter3';
import PolygonLayer from "../../polygon";
import { isNeedMask } from "./util";
export default class Tile extends EventEmitter {
  constructor(sourceTile, parent) {
    super();
    _defineProperty(this, "x", void 0);
    _defineProperty(this, "y", void 0);
    _defineProperty(this, "z", void 0);
    _defineProperty(this, "key", void 0);
    _defineProperty(this, "parent", void 0);
    _defineProperty(this, "sourceTile", void 0);
    _defineProperty(this, "visible", true);
    _defineProperty(this, "layers", []);
    _defineProperty(this, "isLoaded", false);
    _defineProperty(this, "tileMaskLayers", []);
    _defineProperty(this, "tileMask", void 0);
    this.parent = parent;
    this.sourceTile = sourceTile;
    this.x = sourceTile.x;
    this.y = sourceTile.y;
    this.z = sourceTile.z;
    this.key = `${this.x}_${this.y}_${this.z}`;
  }
  getLayers() {
    return this.layers;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  styleUpdate(...arg) {
    return;
  }
  lnglatInBounds(lnglat) {
    const [minLng, minLat, maxLng, maxLat] = this.sourceTile.bounds;
    const {
      lng,
      lat
    } = lnglat;
    return lng >= minLng && lng <= maxLng && lat >= minLat && lat <= maxLat;
  }
  getLayerOptions() {
    var _options$maskLayers;
    const options = this.parent.getLayerConfig();
    return _objectSpread(_objectSpread({}, options), {}, {
      textAllowOverlap: true,
      // 文本允许重叠
      autoFit: false,
      maskLayers: this.getMaskLayer(),
      tileMask: isNeedMask(this.parent.type),
      mask: options.mask || ((_options$maskLayers = options.maskLayers) === null || _options$maskLayers === void 0 ? void 0 : _options$maskLayers.length) !== 0 && options.enableMask
    });
  }
  // 获取Mask 图层
  getMaskLayer() {
    const {
      maskLayers
    } = this.parent.getLayerConfig();
    const layers = [];
    maskLayers === null || maskLayers === void 0 || maskLayers.forEach(layer => {
      if (!layer.tileLayer) {
        // 非瓦片图层返回图层本身，瓦片图层返回对应的行列号图层
        layers.push(layer);
        return layer;
      }
      const tileLayer = layer.tileLayer;
      const tile = tileLayer.getTile(this.sourceTile.key);
      const l = tile === null || tile === void 0 ? void 0 : tile.getLayers()[0];
      if (l) {
        layers.push(l);
      }
    });
    return layers;
  }
  addTileMask() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const mask = new PolygonLayer({
        name: 'mask',
        visible: true,
        enablePicking: false
      }).source({
        type: 'FeatureCollection',
        features: [_this.sourceTile.bboxPolygon]
      }, {
        parser: {
          type: 'geojson',
          featureId: 'id'
        }
      }).shape('fill').color('#0f0').style({
        opacity: 0.5
      });
      const container = createLayerContainer(_this.parent.container);
      mask.setContainer(container);
      yield mask.init();
      _this.tileMask = mask;
      const mainLayer = _this.getMainLayer();
      if (mainLayer !== undefined) {
        mainLayer.tileMask = mask;
      }
      return mask;
    })();
  }
  // 全局 Mask
  addMask(layer, mask) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      const container = createLayerContainer(_this2.parent.container);
      mask.setContainer(container);
      yield mask.init();
      layer.addMask(mask);
      _this2.tileMaskLayers.push(mask);
    })();
  }
  addLayer(layer) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      // set flag
      layer.isTileLayer = true;
      const container = createLayerContainer(_this3.parent.container);
      layer.setContainer(container);
      _this3.layers.push(layer);
      yield layer.init();
    })();
  }
  updateVisible(value) {
    this.visible = value;
    this.updateOptions('visible', value);
  }
  updateOptions(key, value) {
    this.layers.forEach(l => {
      l.updateLayerConfig({
        [key]: value
      });
    });
  }

  /**
   * 一个 Tile 可能有多个 layer，但是在发生拾取、点击事件的时候只有一个生效
   */
  getMainLayer() {
    return this.layers[0];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getFeatures(sourceLayer) {
    return [];
  }

  /**
   * 在一个 Tile 中可能存在一个相同 ID 的 feature
   * @param id
   * @returns
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getFeatureById(id) {
    return [];
  }
  destroy() {
    var _this$tileMask;
    (_this$tileMask = this.tileMask) === null || _this$tileMask === void 0 || _this$tileMask.destroy();
    this.layers.forEach(layer => layer.destroy());
  }
}